<template>
    <div>
        <el-form class="form" ref="form" label-width="80px">
            <el-checkbox class="checkbox" v-model="checked"></el-checkbox>
            <el-form-item label="标签修饰" style="margin-bottom:12px;">
                <el-radio-group v-model="data">
                    <el-radio label="grammar">语法点</el-radio>
                    <el-radio label="review">复习</el-radio>
                    <el-radio label="explain">讲解</el-radio>
                    <el-radio label="example">例句</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import attributeMixin from '../../mixins/graphic/attribute'
export default {
    name: 'Tags',
    mixins: [attributeMixin],
    data() {
        return {
            type: 'Tags',
            default: 0,
        }
    },
}
</script>
<style lang="scss">
.form {
    display: flex;
    align-items: center;
}
</style>